import classNames from "classnames";
import { AscButton } from "../../components";
import AscHeading from "../../components/AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../components/AscTypography/AscParagraph/AscParagraph";
import AscAuthFlowLayout from "../AscAuthFlowLayout/AscAuthFlowLayout";
import styles from "./AscPasswordChangedView.module.scss";

export interface AscPasswordChangedViewProps {
  className?: string;
  onSignIn: () => void;
}

export default function AscPasswordChangedView({
  className,
  onSignIn,
}: AscPasswordChangedViewProps) {
  return (
    <AscAuthFlowLayout alignment="right" roundSideImage>
      <div
        data-testid="asc-password-changed-view"
        className={classNames(styles.ground, className)}
      >
        <header className={styles.heading}>
          <AscHeading className={styles.title} level={1}>
            Password changed
          </AscHeading>
          <AscParagraph className={styles.subTitle}>
            Your password has been successfully changed
          </AscParagraph>
        </header>
        <footer className={styles.footer}>
          <AscButton
            className={styles.footerButton}
            variant="primary"
            size="large"
            fullWidth
            onClick={onSignIn}
            data-testid="asc-password-changed-submit"
          >
            Sign in
          </AscButton>
        </footer>
      </div>
    </AscAuthFlowLayout>
  );
}
